import styled, { css } from "styled-components";

import Tippy from "@tippyjs/react";

import "tippy.js/dist/tippy.css";

export const Container = styled.div`
  cursor: pointer;

  ${({ childrenWithEllipsis }: { childrenWithEllipsis: boolean }) =>
    childrenWithEllipsis &&
    css`
      width: 100%;
    `}
`;

export const StyledTippy = styled(Tippy)`
  .tippy-content {
    font-family: "Roboto";
    font-size: 12px;
    line-height: 1.67;

    padding: 10px 12px;
    overflow-wrap: break-word;
    word-break: break-word;
  }
`;
